import React from 'react';
import {makeStyles} from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import {theme} from '../../Theme';

const useStyles = (props: $TSFixMe) =>
  makeStyles(() => ({
    iconButton: {
      '&:hover': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: `${theme.palette.secondary.main} !important`,
      },

      '&:disabled': {
        opacity: '33%',
      },
    },
  }));

export default function BidmiiIconButton(props: $TSFixMe) {
  const classes = useStyles(props)();

  return (
    <IconButton
      onClick={props.onClick}
      disabled={props.disabled}
      className={`${classes.iconButton} ${props.className}`}
      style={{
        ...props.style,
        width: props.size || 36,
        height: props.size || 36,

        backgroundColor: props.color
          ? props.color
          : theme.palette.secondary.main,
        color: props.disabled
          ? theme.palette.gray.border
          : props.secondary
            ? theme.palette.primary.light
            : props.iconColor || theme.palette.primary.main,
        border: props.secondary
          ? `1px solid ${theme.palette.gray.dark}`
          : props.border || 'none',
      }}
      component={props.component}
      type={props.type || undefined}
      id={props.id || undefined}
      size="large">
      {props.children}
    </IconButton>
  );
}
